import React, {useState} from "react";
import "./Ghq12Page.css";
import {trackTestStarted, trackTestFinished} from "../analytics";

const QUESTIONS = [
    {id: 1, polarity: "pos", text: "Avez-vous été capable de vous concentrer sur tout ce que vous faites ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
    {id: 2, polarity: "neg", text: "Avez-vous manqué de sommeil à cause de vos soucis ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Un peu plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 3, polarity: "pos", text: "Vous êtes-vous senti(e) capable de prendre des décisions ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
    {id: 4, polarity: "neg", text: "Vous êtes-vous senti(e) constamment tendu(e) ou stressé(e) ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 5, polarity: "pos", text: "Avez-vous eu le sentiment de jouer un rôle utile dans la vie ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
    {id: 6, polarity: "neg", text: "Avez-vous eu le sentiment que vous ne pourriez pas surmonter vos difficultés ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 7, polarity: "pos", text: "Avez-vous été capable d'apprécier vos activités quotidiennes normales ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
    {id: 8, polarity: "pos", text: "Avez-vous été capable de faire face à vos problèmes ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
    {id: 9, polarity: "neg", text: "Avez-vous été malheureux(se) et déprimé(e) ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 10, polarity: "neg", text: "Avez-vous perdu confiance en vous-même ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 11, polarity: "neg", text: "Vous êtes-vous considéré(e) comme quelqu'un qui ne valait rien ?", opts: ["Pas du tout", "Moins que d'habitude", "Comme d'habitude", "Plus que d'habitude", "Beaucoup plus que d'habitude"]},
    {id: 12, polarity: "pos", text: "Vous êtes-vous senti(e) raisonnablement heureux(se), tout bien considéré ?", opts: ["Beaucoup plus que d'habitude", "Plus que d'habitude", "Comme d'habitude", "Moins que d'habitude", "Beaucoup moins que d'habitude"]},
];

const RESULTS = [
    {
        min: 0, max: 12, emoji: "🟢", tierClass: "ghq-tier-vert",
        label: "Votre équilibre mental semble bien préservé",
        message: "Ces résultats indiquent que vous traversez actuellement cette période sans détresse psychologique notable. Votre capacité à fonctionner et à vous adapter paraît intacte.",
        precos: [
            {text: "Préserver des temps de récupération réels : sommeil, activités de plaisir, liens sociaux."},
            {text: "Rester attentif(ve) aux signaux faibles si la situation professionnelle venait à évoluer."},
            {text: "Ce questionnaire peut être refait dans quelques semaines si vous traversez une période plus difficile."},
        ],
    },
    {
        min: 13, max: 24, emoji: "🟡", tierClass: "ghq-tier-jaune",
        label: "Des signes de tension sont présents — restez attentif(ve)",
        message: "Votre score indique une certaine détresse psychologique. Ce n'est pas une alarme, mais un signal que quelque chose mérite attention. Il est fréquent de traverser des périodes de tension — l'important est de ne pas les minimiser.",
        precos: [
            {text: "En parler à un proche de confiance, à votre médecin traitant, ou à un professionnel de santé mentale."},
            {text: "Identifier les sources de tension : travail, organisation, relations, charge mentale ?"},
            {text: "Consulter le médecin de prévention de votre ministère (confidentiel, sans passer par la hiérarchie)."},
            {text: "Contacter un représentant SAPPM si la situation est liée au travail."},
        ],
    },
    {
        min: 25, max: 36, emoji: "🟠", tierClass: "ghq-tier-orange",
        label: "Une détresse significative est détectée — parlez-en à un professionnel",
        message: "Votre score signale une détresse psychologique importante. Cela ne signifie pas que vous êtes fragile — cela signifie que vous portez probablement trop depuis trop longtemps. Consulter un professionnel de santé est la démarche la plus adaptée.",
        precos: [
            {text: "Votre médecin traitant est le premier interlocuteur : il peut vous évaluer et vous orienter."},
            {text: "Un psychiatre (médecin spécialiste) peut poser un diagnostic et prescrire un traitement si nécessaire."},
            {
                text: "Un psychologue ou psychothérapeute pour un accompagnement par la parole.",
                link: "https://www.psycom.org/sinformer/le-retablissement/les-professionnels-de-la-sante-mentale/",
                linkLabel: "En savoir plus"
            },
            {text: "Le médecin de prévention de votre ministère : confidentiel, sans lien avec votre hiérarchie."},
            {text: "Pour trouver un professionnel près de chez vous : annuaires locaux Psycom.", link: "https://www.psycom.org/sorienter/les-annuaires-locaux/les-structures-de-sante-mentale/"},
            {text: "Contacter SAPPM si la situation est liée au travail."},
        ],
    },
    {
        min: 37, max: 48, emoji: "🔴", tierClass: "ghq-tier-rouge",
        label: "Une souffrance intense est détectée — cherchez de l'aide dès aujourd'hui",
        message: "Votre score est élevé et indique une souffrance psychologique importante. Ce niveau de détresse mérite une attention immédiate. Vous n'êtes pas seul(e), et des personnes compétentes peuvent vous aider dès maintenant.",
        precos: [
            {text: "3114 — Numéro national de prévention, disponible 24h/24, 7j/7. Des professionnels de santé mentale vous répondent pour toute souffrance psychique."},
            {text: "Votre médecin traitant aujourd'hui : demandez un rendez-vous urgent en mentionnant votre état de détresse."},
            {
                text: "Un psychiatre : en urgence, vous pouvez vous rendre directement aux urgences psychiatriques.",
                link: "https://www.psycom.org/sinformer/le-retablissement/les-soins/les-urgences/",
                linkLabel: "Infos urgences psychiatriques"
            },
            {text: "Pour trouver une structure de soin près de chez vous : annuaires Psycom.", link: "https://www.psycom.org/sorienter/les-annuaires-locaux/les-structures-de-sante-mentale/"},
            {text: "Contacter SAPPM si cette souffrance est liée au travail — en toute confidentialité."},
        ],
    },
];

function calcScore(answers) {
    let score = 0;
    for (let i = 0; i < 12; i++) {
        if (answers[i] !== null) score += answers[i];
    }
    return score;
}

export default function Ghq12Page({onBack}) {
    const [phase, setPhase] = useState("intro");
    const [answers, setAnswers] = useState(new Array(12).fill(null));
    const [cur, setCur] = useState(0);

    const allAnswered = answers.every(a => a !== null);
    const score = allAnswered ? calcScore(answers) : null;
    const result = score !== null ? RESULTS.find(r => score >= r.min && score <= r.max) : null;

    function selectOption(idx) {
        const next = [...answers];
        next[cur] = idx;
        setAnswers(next);
    }

    function restart() {
        setAnswers(new Array(12).fill(null));
        setCur(0);
        setPhase("intro");
    }

    return (
        <div className="ghq-page">
            {/* HEADER — identique QVT */}
            <header className="qvt-header">
                <div className="qvt-header-inner">
                    <div className="qvt-header-left">
                        <img src="/paroles-agents-logo.png" alt="SAPPM" className="qvt-header-logo"/>
                        <div className="qvt-brand">
                            <span className="qvt-brand-title">Paroles d'Agents</span>
                            <span className="qvt-brand-tagline">Pour que chacun s'exprime&nbsp;!</span>
                        </div>
                    </div>
                    <div className="qvt-header-center">
                        <span className="qvt-header-headline">Réseau d'échange, de propositions et d'alertes</span>
                        <span className="qvt-header-subtext">Ensemble, faisons entendre la voix des agents 💚</span>
                    </div>
                    <div className="qvt-header-right">
                        {onBack && <button className="qvt-btn-back" onClick={onBack}>← Retour à la page d'accueil</button>}
                    </div>
                </div>
            </header>

            <div className="ghq-wrapper">
                {onBack && (
                    <button className="ghq-btn-home" onClick={onBack}>← Retour à la page d'accueil</button>
                )}

                {/* ── INTRO ── */}
                {phase === "intro" && (
                    <div>
                        <p className="ghq-eyebrow">Questionnaire GHQ-12 — D.P. Goldberg</p>
                        <h1 className="ghq-title">Évaluez votre<br/><em>santé mentale</em></h1>
                        <p className="ghq-subtitle">Un questionnaire validé pour faire le point sur votre bien-être</p>

                        <div className="ghq-intro-card">
                            <p>Ce questionnaire, conçu par le Dr David Goldberg et utilisé dans de nombreux pays, explore comment vous vous êtes senti(e) <strong>ces dernières semaines</strong>. Il ne s'agit pas d'un diagnostic médical, mais d'un outil pour faire le point sur votre état de bien-être général.</p>
                            <p>Répondez à chaque question en pensant à ce que vous ressentez <strong>aujourd'hui</strong>, par rapport à votre état habituel. Il n'y a pas de bonne ou de mauvaise réponse.</p>
                            <p><strong>Ce questionnaire est anonyme et confidentiel.</strong></p>
                        </div>

                        <div className="ghq-info-card">
                            <h2 className="ghq-info-title">Pourquoi ce test ?</h2>
                            <p>Ce test d'auto-évaluation (GHQ-12) est un outil scientifiquement validé, utilisé internationalement pour repérer une souffrance psychique naissante. Il ne remplace en rien un avis médical : il vous aide simplement à faire le point, en quelques minutes et en toute confidentialité.</p>
                            <p>Sa mise à disposition ici s'inscrit dans une démarche encouragée par l'administration elle-même. La <a href="https://www.legifrance.gouv.fr/circulaire/id/45298" target="_blank" rel="noopener noreferrer" className="ghq-info-link">circulaire du 23 février 2022</a> relative aux actions de sensibilisation et de formation au secourisme en santé mentale dans la fonction publique invite chaque employeur public à développer une véritable culture de prévention des situations de détresse psychique, et à faire connaître les ressources disponibles auprès des agents.</p>
                            <p>C'est dans cet esprit que le SAPPM vous propose cet outil.</p>

                            <h2 className="ghq-info-title">Et après le test ?</h2>
                            <p>Quel que soit votre résultat, sachez que des secouristes en santé mentale existent au sein de votre administration. Formés dans le cadre de ce même dispositif national, ils sont là pour écouter, orienter, et vous accompagner vers les bons interlocuteurs (médecine du travail, psychologue, psychiatre). Il appartient à votre administration de vous communiquer la liste des secouristes formés en son sein — n'hésitez pas à la lui réclamer si elle n'est pas encore accessible.</p>
                        </div>

                        <div className="ghq-meta">
                            <span className="ghq-meta-item"><span className="ghq-dot"/>12 questions</span>
                            <span className="ghq-meta-item"><span className="ghq-dot"/>3 minutes</span>
                            <span className="ghq-meta-item"><span className="ghq-dot"/>Anonyme &amp; confidentiel</span>
                        </div>

                        <button className="ghq-btn-start" onClick={() => { trackTestStarted("ghq12"); setCur(0); setAnswers(new Array(12).fill(null)); setPhase("quiz"); }}>
                            Commencer →
                        </button>
                    </div>
                )}

                {/* ── QUIZ ── */}
                {phase === "quiz" && (
                    <div>
                        <div className="ghq-progress-wrap">
                            <div className="ghq-progress-label">Question {cur + 1} / 12</div>
                            <div className="ghq-progress-track">
                                <div className="ghq-progress-fill" style={{width: `${((cur + 1) / 12) * 100}%`}}/>
                            </div>
                        </div>

                        <div className="ghq-question-card">
                            <div className="ghq-question-num">Question {cur + 1}</div>
                            <div className="ghq-question-text">{QUESTIONS[cur].text}</div>
                        </div>

                        <div className="ghq-options-list">
                            {QUESTIONS[cur].opts.map((label, i) => (
                                <button
                                    key={i}
                                    className={`ghq-option-btn${answers[cur] === i ? " selected" : ""}`}
                                    onClick={() => selectOption(i)}
                                >
                                    <span className="ghq-opt-marker"/>
                                    <span>{label}</span>
                                </button>
                            ))}
                        </div>

                        <div className="ghq-nav-row">
                            <button className="ghq-btn-prev" onClick={() => setCur(c => c - 1)} disabled={cur === 0}>
                                ← Précédent
                            </button>
                            {allAnswered && (
                                <button className="ghq-btn-result" onClick={() => { trackTestFinished("ghq12"); setPhase("result"); }}>
                                    Voir mon résultat
                                </button>
                            )}
                            <button className="ghq-btn-next" onClick={() => setCur(c => c + 1)} disabled={answers[cur] === null || cur === 11}
                                style={{visibility: cur === 11 ? "hidden" : "visible"}}>
                                Suivant →
                            </button>
                        </div>
                    </div>
                )}

                {/* ── RÉSULTAT ── */}
                {phase === "result" && result && (
                    <div>
                        <div className={`ghq-result-header ${result.tierClass}`}>
                            <div className="ghq-result-emoji">{result.emoji}</div>
                            <div className="ghq-result-label">{result.label}</div>
                            <div className="ghq-result-score">Score obtenu : {score} / 48</div>
                        </div>

                        <div className="ghq-result-message">{result.message}</div>

                        <div className="ghq-result-precos">
                            <h3>Que faire maintenant ?</h3>
                            <ul>
                                {result.precos.map((p, i) => (
                                    <li key={i}>
                                        {p.link
                                            ? p.linkLabel
                                                ? <>{p.text} <a href={p.link} target="_blank"
                                                                rel="noopener noreferrer">{p.linkLabel}</a></>
                                                : <>{p.text.split("Psycom")[0]}<a href={p.link} target="_blank"
                                                                                  rel="noopener noreferrer">Psycom{p.text.split("Psycom")[1]}</a></>
                                            : p.text
                                        }
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className="ghq-disclaimer">
                            <strong>Avis important :</strong> Ce questionnaire est un outil de dépistage informatif, non un acte médical. Il ne remplace en aucun cas une consultation auprès d'un professionnel de santé. Si vous êtes en situation de détresse, consultez votre médecin traitant ou appelez le <strong>3114</strong> (numéro national de prévention, 24h/24).
                        </div>

                        <div className="ghq-result-actions">
                            <button className="ghq-btn-prev" onClick={restart}>↩ Recommencer</button>
                            {onBack && <button className="ghq-btn-start" onClick={onBack}>← Retour à l'accueil</button>}
                        </div>
                    </div>
                )}

                <div className="ghq-footer">
                    Questionnaire GHQ-12 — D.P. Goldberg &nbsp;|&nbsp; Paroles d'Agents — SAPPM &nbsp;|&nbsp; Outil informatif, non diagnostique
                </div>
            </div>
        </div>
    );
}
